export default "__VITE_ASSET__CugB9CxD__"